export function setCookie(name: string, value: string, days: number) {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = "expires=" + date.toUTCString();
  const secure = window.location.protocol === 'https:' ? ';Secure' : '';
  document.cookie = `${name}=${value};${expires};path=/;SameSite=Lax${secure}`;
}

// Delete a cookie by setting its expiration to a time in the past
export function deleteCookie(name: string) {
  const expires = "expires=Thu, 01 Jan 1970 00:00:00 UTC";
  document.cookie = `${name}=;${expires};path=/;SameSite=Lax`;
}

export function getCookie(name: string): string | null {
  const nameEQ = name + "=";
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i];
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1, cookie.length);
    }
    if (cookie.indexOf(nameEQ) === 0) {
      return cookie.substring(nameEQ.length, cookie.length);
    }
  }
  return null;
}

export function setRefreshTokenCookie(value: string, days: number) {
  setCookie('refresh_token', value, days);
}

export function getRefreshTokenCookie(): string | null {
  return getCookie('refresh_token');
}

export function clearAuthCookies(): void {
  deleteCookie('token');
  deleteCookie('refresh_token');
}